import styles from "./Subtitle.module.css";
import { enableBrTags } from "../../../utils/titleUtils";

type subtitleProps = {
    title: string;
    subtitle: string;
    heading?: string;
};
export const Subtitle = ({ title, subtitle, heading = "" }: subtitleProps) => {
    return (
        <div className={styles.subtitleContainer}>
            {title && <h1 className={styles.title}>{enableBrTags(title)}</h1>}
            {subtitle && <h2 className={styles.subtitle}>{enableBrTags(subtitle)}</h2>}
            {heading && (
                <h3 className={styles.heading}>{enableBrTags(heading)}</h3>
            )}
        </div>
    );
};
